
import React from "react";
import { Button } from "@/components/ui/button";
import { UseFormReturn } from "react-hook-form";

interface FormActionsProps {
  form: UseFormReturn<any>;
  isSubmitting: boolean;
  isEditing: boolean;
  onCancel: () => void;
}

export function FormActions({ form, isSubmitting, isEditing, onCancel }: FormActionsProps) {
  return (
    <div className="flex justify-end gap-4 mt-6">
      <Button
        type="button"
        variant="outline"
        onClick={onCancel}
        disabled={isSubmitting}
      >
        Cancel
      </Button>
      <Button
        type="submit"
        disabled={isSubmitting || !form.formState.isDirty}
      >
        {isEditing ? 'Update' : 'Create'} Measurement
      </Button>
    </div>
  );
}
